import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/shell-logo.png")